import React, { useEffect, useState, useMemo } from 'react';
import { Space, Table, Tag, Button, Image, Card, Input, Flex, Select, Modal, Form } from 'antd';
import { useNavigate, useSearchParams } from "react-router";
import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { useForm, useWatch } from "antd/es/form/Form";
import UserService from 'services/user';
import { useApp } from "contexts/app";
import { useAuth } from "contexts/auth";
import _ from "lodash"
const { Search } = Input;
const service = new UserService();


const UserList = () => {
    let navigate = useNavigate();
    const [data, setData] = useState([]);
    const { showNotify, modal, showLoading, prompt } = useApp();
    const [filter, setFilter] = useState({})

    const [showAddUser, setShowAddUser] = useState(false)
    const { user ,switchWorkSpace} = useAuth();


    useEffect(() => {
        loadData();


    }, [])


    const loadData = async () => {
        var list = await service.getWorkSpaces();
        setData(list);
    }



    const switchWP = (id) => {



    }




    const columns = [
        {
            title: 'Shop ',
            render: (_, record) => {
                return (
                    <div>
                        <Space>

                            <div>
                                {record.work_space.name} 
                            </div>
                        </Space>
                    </div>

                )
            }
        },


        {
            title: "",
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    {user.work_space.w_id != record.w_id ?
                        <Button type='link' onClick={e => switchWorkSpace(record.w_id)}>Đăng nhập</Button>
                        :
                        <>Đang đăng nhập</>

                    }


                </Space>
            ),
        },
    ];



    return (

        <Space direction="vertical" size={16} style={{ width: "100%" }}>

            <Card>
                <Table columns={columns} dataSource={data} />
            </Card>

        </Space>
    )
}





export default UserList;